import { useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import _ from "lodash";

import classes from "../../maintainers.module.scss";

import { customStyles } from "./business_center.constants";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const filter_business_center = [
	{ value: "historico", label: "Históricos" },
	{ value: "activos", label: "Activos" },
];

const BusinessCenterFilter = ({ filter, applyFilter }) => {
	const { customer } = useSelector((state) => state.auth.user);

	const { estates, categories, species, varieties, quarters } = useSelector((state) => state.maintainers_business_center);

	const [filterType, setFilterType] = useState(filter.filter_type);
	const [estateFilter, setEstateFilter] = useState(filter.filter_estate);
	const [specieFilter, setSpecieFilter] = useState(filter.filter_specie);
	const [categoryFilter, setCategoryFilter] = useState(filter.filter_category);
	const [varietyFilter, setVarietyFilter] = useState(filter.filter_variety);
	const [quarterFilter, setQuarterFilter] = useState(filter.filter_quarter);

	const handleApplyFilter = () => {
		applyFilter({
			filterType,
			estateFilter,
			specieFilter,
			varietyFilter,
			quarterFilter,
			categoryFilter,
		});
	};

	const handleCleanFilter = () => {
		applyFilter({
			filterType: "",
			estateFilter: "",
			specieFilter: "",
			varietyFilter: "",
			quarterFilter: "",
			categoryFilter: "",
		});
	};

	return (
		<Col md={3} className={classes.filter}>
			<h4 className={classes.filterTitle}>Filtros</h4>
			<hr style={{ marginTop: "0.5em", marginBottom: "0.5em" }} />

			<div className={classes.divContent}>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Tipo</span>
					</Col>

					<Col md={12}>
						<Select
							value={filter_business_center.filter((tbc) => tbc.value === filterType)}
							placeholder={<div>Seleccione</div>}
							options={filter_business_center ? filter_business_center : []}
							onChange={(value) => {
								setFilterType(value.value);
							}}
							components={{
								NoOptionsMessage,
							}}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>
							{customer.use_estates_parents
								? customer.customer_screens.find((cs) => cs.screen_id === 51)
									? customer.customer_screens.find((cs) => cs.screen_id === 51)?.name
									: "Bodega"
								: "Campo"}
						</span>
					</Col>
					<Col md={12}>
						<Select
							value={
								estates &&
								estates.filter(
									(a) => estateFilter && estateFilter.length > 0 && _.map(estateFilter.split(","), Number).includes(Number(a.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={estates ? estates : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setEstateFilter(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							styles={customStyles}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Categorías</span>
					</Col>
					<Col md={12}>
						<Select
							value={
								categories &&
								categories.filter(
									(a) => categoryFilter && categoryFilter.length > 0 && _.map(categoryFilter.split(","), Number).includes(Number(a.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={categories ? categories : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setCategoryFilter(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							styles={customStyles}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Paso 1</span>
					</Col>
					<Col md={12}>
						<Select
							value={
								species &&
								species.filter(
									(a) => specieFilter && specieFilter.length > 0 && _.map(specieFilter.split(","), Number).includes(Number(a.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={species ? species.filter((s) => _.map(categoryFilter.split(","), Number).includes(Number(s.category_id))) : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setSpecieFilter(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							styles={customStyles}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Paso 2</span>
					</Col>
					<Col md={12}>
						<Select
							value={
								varieties &&
								varieties.filter(
									(a) => varietyFilter && varietyFilter.length > 0 && _.map(varietyFilter.split(","), Number).includes(Number(a.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={varieties ? varieties.filter((s) => _.map(specieFilter.split(","), Number).includes(Number(s.specie_id))) : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setVarietyFilter(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							styles={customStyles}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Paso 3</span>
					</Col>
					<Col md={12}>
						<Select
							value={
								quarters &&
								quarters.filter(
									(a) => quarterFilter && quarterFilter.length > 0 && _.map(quarterFilter.split(","), Number).includes(Number(a.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={quarters ? quarters.filter((s) => _.map(varietyFilter.split(","), Number).includes(Number(s.variety_id))) : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setQuarterFilter(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							styles={customStyles}
						/>
					</Col>
				</Row>
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default BusinessCenterFilter;
